module.exports = __webpack_public_path__ + "images/daihatsu72d88f1da19667d39270186e694176c8.png";